// extracted by mini-css-extract-plugin
export var contentBody = "_d4-9";
export var headerImage = "_d4-2";
export var imageButton = "_d4-7";
export var imageButtonIcon = "_d4-8";
export var imageHeader = "_d4-4";
export var imageHeaderText = "_d4-5";
export var imageOverlay = "_d4-3";
export var imageTitle = "_d4-6";
export var imageWrapper = "_d4-1";
export var taskList = "_d4-a";
export var widget = "_d4-0";